var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatTileGauge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3D4C59",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 4c1.607 0 3.168.34 4.598.986.503.228.727.82.5 1.323-.229.504-.821.727-1.324.5C14.602 6.278 13.322 6 12 6c-4.975 0-9 3.944-9 8.8 0 .608.148 1.44.452 2.48.114.388.447.666.84.713l.12.007h15.176c.444 0 .835-.293.96-.72.304-1.04.452-1.872.452-2.48 0-1.085-.2-2.141-.586-3.132-.2-.515.054-1.094.568-1.295.515-.2 1.095.054 1.295.569.476 1.221.723 2.523.723 3.858 0 .825-.18 1.834-.533 3.041-.356 1.221-1.441 2.078-2.699 2.154l-.18.005H4.412c-1.333 0-2.506-.88-2.88-2.159C1.18 16.634 1 15.625 1 14.8 1 8.83 5.93 4 12 4zm-.957 8.244l8.782-4.724-1.888 2.425-1.56 1.977-1.233 1.53-.604.728-.39.457-.31.345-.178.185-.093.089-.046.04c-.366.43-.913.704-1.523.704-1.105 0-2-.895-2-2 0-.695.355-1.308.893-1.666l.15-.09z",
    transform: "translate(-200 -639) translate(200 639)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatTileGauge);
export default __webpack_public_path__ + "static/media/statTileGauge.5ed0b4b9.svg";
export { ForwardRef as ReactComponent };